import { render, staticRenderFns } from "./tableSR.vue?vue&type=template&id=038d715c&scoped=true&"
import script from "./tableSR.vue?vue&type=script&lang=js&"
export * from "./tableSR.vue?vue&type=script&lang=js&"
import style0 from "./tableSR.vue?vue&type=style&index=0&id=038d715c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d715c",
  null
  
)

export default component.exports